import { Box, Table, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react'
import { isEmpty } from 'lodash'
import React from 'react'
import { AccountType, AlpsAcatDetailV2WebDto } from '../../../../api/types'

export interface TransferDetailsProps {
  transferDetail: AlpsAcatDetailV2WebDto
}

const getAccountType = (accountTypes: AccountType[]) => {
  return accountTypes.join(', ')
}

const AccountInformation = ({ transferDetail }: TransferDetailsProps) => {
  return (
    <Box>
      <Box bg="gray.600" color="apex.white" p={3}>
        <Text fontWeight="bold">Account Information</Text>
      </Box>
      <Table>
        <Thead>
          <Tr>
            <Th>Info</Th>
            <Th>Delivering Account</Th>
            <Th>Receiving Account</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td w="24%" fontWeight="semibold" verticalAlign="top">
              Title
            </Td>
            <Td w="38%">{transferDetail.deliverer.accountTitle || '—'}</Td>
            <Td w="38%">{transferDetail.receiver.accountTitle || '—'}</Td>
          </Tr>
          <Tr>
            <Td fontWeight="semibold" verticalAlign="top">
              Number
            </Td>
            <Td>{transferDetail.deliverer.accountNumber || '—'}</Td>
            <Td>{transferDetail.receiver.accountNumber || '—'}</Td>
          </Tr>
          <Tr>
            <Td fontWeight="semibold" verticalAlign="top">
              Type
            </Td>
            <Td>
              {isEmpty(transferDetail.deliverer.accountTypes)
                ? '—'
                : `${getAccountType(transferDetail.deliverer.accountTypes)}`}
            </Td>
            <Td>
              {isEmpty(transferDetail.receiver.accountTypes)
                ? '—'
                : `${getAccountType(transferDetail.receiver.accountTypes)}`}
            </Td>
          </Tr>
          <Tr>
            <Td fontWeight="semibold" verticalAlign="top">
              Cash/Margin
            </Td>
            <Td>
              {transferDetail.deliverer.isMarginAccount ? 'Margin' : 'Cash'}
            </Td>
            <Td>
              {transferDetail.receiver.isMarginAccount ? 'Margin' : 'Cash'}
            </Td>
          </Tr>
          <Tr>
            <Td fontWeight="semibold" verticalAlign="top">
              Firm
            </Td>
            <Td>{transferDetail.deliverer.participantName || '—'}</Td>
            <Td>{transferDetail.receiver.participantName || '—'}</Td>
          </Tr>
          <Tr>
            <Td fontWeight="semibold" verticalAlign="top">
              SSN/Tax ID
            </Td>
            <Td>{transferDetail.deliverer.primarySsnOrTaxId || '—'}</Td>
            <Td>{transferDetail.receiver.primarySsnOrTaxId || '—'}</Td>
          </Tr>
        </Tbody>
      </Table>
    </Box>
  )
}

export default AccountInformation
